"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorTypeLabel = exports.OperatorType = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
// eslint-disable-next-line no-shadow
var OperatorType;
(function (OperatorType) {
    OperatorType["LESS_THAN"] = "lt";
    OperatorType["GREATER_THAN"] = "gt";
    OperatorType["LESS_THAN_OR_EQUAL"] = "lte";
    OperatorType["GREATER_THAN_OR_EQUAL"] = "gte";
    OperatorType["EQUAL"] = "is";
    OperatorType["NOT_EQUAL"] = "is-not";
    OperatorType["IS_EMPTY"] = "is-empty";
    OperatorType["AFTER"] = "after";
    OperatorType["BEFORE"] = "before";
    OperatorType["BETWEEN"] = "between";
    OperatorType["IS_TRUE"] = "is-true";
    OperatorType["IS_NOT_TRUE"] = "is-not-true";
})(OperatorType = exports.OperatorType || (exports.OperatorType = {}));
exports.default = OperatorType;
function operatorTypeLabel(ot) {
    switch (ot) {
        case OperatorType.LESS_THAN:
            return lib_i18n_1.default.t('lt');
        case OperatorType.GREATER_THAN:
            return lib_i18n_1.default.t('gt');
        case OperatorType.LESS_THAN_OR_EQUAL:
            return lib_i18n_1.default.t('lte');
        case OperatorType.GREATER_THAN_OR_EQUAL:
            return lib_i18n_1.default.t('gte');
        case OperatorType.EQUAL:
            return lib_i18n_1.default.t('is');
        case OperatorType.NOT_EQUAL:
            return lib_i18n_1.default.t('is-not');
        case OperatorType.IS_EMPTY:
            return lib_i18n_1.default.t('is-empty');
        case OperatorType.AFTER:
            return lib_i18n_1.default.t('after');
        case OperatorType.BEFORE:
            return lib_i18n_1.default.t('before');
        case OperatorType.BETWEEN:
            return lib_i18n_1.default.t('between');
        case OperatorType.IS_TRUE:
            return lib_i18n_1.default.t('is-true');
        case OperatorType.IS_NOT_TRUE:
            return lib_i18n_1.default.t('is-not-true');
    }
}
exports.operatorTypeLabel = operatorTypeLabel;
